import {
	withViewExperienceTracker,
	type InjectedProps,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking';
import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import type { Props } from './types';
import View from './view';

const Issues = connect(mapStateToProps, mapDispatchToProps)(View);

// @ts-expect-error - connect does not have a component interface for `why-did-you-render`
Issues.whyDidYouRender = true;
Issues.displayName = 'Issues';

// Type Props is polluted with intl and connect
export default withViewExperienceTracker<Flow.Diff<Props, InjectedProps>>(
	// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<{ clearFilters: () => void; onToggle: (payload: Partial<Record<string, boolean>>) => { type: "state.domain.view-settings.issue-expansions.SET_IS_EXPANDED"; payload: Partial<...>; }; onMove: (payload: MoveIssuePayload) => { ...; }; onInvalidRanking: (payload: FlagActionPayload) => FlagAction; togg...' is not assignable to parameter of type 'AbstractComponent<Diff<Props, InjectedProps> & InjectedProps, any>'.
	Issues,
	'portfolio-3.simple-plans.roadmap.issues-column',
);
